export class VehicleModelImageDto {
    constructor(initializer) {
        this.id = initializer.id;
        this.url = initializer.url;
        this.deletedAt = initializer.deletedAt;
    }
}
